import React, { useEffect, useState } from "react";
import { usePushNotifications } from "./usePushNotifications";

// Shows a gentle permission prompt after the user has completed their first practice
export default function PushNotificationPrompt({ onDismiss }) {
  const { permission, isSupported, requestPermission, error } = usePushNotifications();
  const [status, setStatus] = useState("idle"); // idle | requesting | success | denied | unsupported

  useEffect(() => {
    if (!isSupported) setStatus("unsupported");
  }, [isSupported]);

  if (!isSupported || permission === "granted") return null;

  const handleEnable = async () => {
    setStatus("requesting");
    const granted = await requestPermission();
    setStatus(granted ? "success" : "denied");
    if (granted) {
      setTimeout(() => onDismiss && onDismiss(), 2000);
    }
  };

  if (status === "success") {
    return (
      <div style={styles.banner}>
        <span style={styles.icon}>🔔</span>
        <span style={styles.msg}>Morning reminders enabled. See you tomorrow.</span>
      </div>
    );
  }

  if (status === "denied" || permission === "denied") {
    return null; // Don't nag
  }

  return (
    <div style={styles.card}>
      <div style={styles.inner}>
        <div style={styles.left}>
          <span style={styles.bigIcon}>🌅</span>
          <div>
            <p style={styles.title}>Get your morning nudge</p>
            <p style={styles.sub}>A gentle reminder each morning to roll the dice.</p>
          </div>
        </div>
        <div style={styles.buttons}>
          <button
            style={styles.enableBtn}
            onClick={handleEnable}
            disabled={status === "requesting"}
          >
            {status === "requesting" ? "Setting up…" : "Enable"}
          </button>
          <button style={styles.dismissBtn} onClick={onDismiss}>
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: {
    background: "rgba(139,92,246,0.08)",
    border: "1px solid rgba(139,92,246,0.25)",
    borderRadius: "12px",
    padding: "16px 18px",
    margin: "16px 0",
  },
  inner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
  },
  left: { display: "flex", alignItems: "center", gap: "12px" },
  bigIcon: { fontSize: "24px" },
  title: { fontSize: "14px", fontWeight: "600", color: "#e2d9f3", margin: "0 0 3px" },
  sub: { fontSize: "12px", color: "#6b7280", margin: 0 },
  buttons: { display: "flex", gap: "8px", flexShrink: 0 },
  enableBtn: {
    background: "linear-gradient(135deg, #7c3aed, #5b21b6)",
    color: "#fff", border: "none", borderRadius: "8px",
    padding: "8px 16px", fontSize: "13px", fontWeight: "600", cursor: "pointer",
  },
  dismissBtn: {
    background: "none", border: "1px solid rgba(255,255,255,0.15)",
    color: "#6b7280", borderRadius: "8px",
    padding: "8px 14px", fontSize: "13px", cursor: "pointer",
  },
  banner: {
    display: "flex", alignItems: "center", gap: "10px",
    background: "rgba(34,197,94,0.1)", border: "1px solid rgba(34,197,94,0.3)",
    borderRadius: "8px", padding: "10px 14px", margin: "12px 0",
  },
  icon: { fontSize: "16px" },
  msg: { fontSize: "13px", color: "#86efac" },
};
